import { render } from "./DonationsReport.vue?vue&type=template&id=94aba2e6&scoped=true"
import script from "./DonationsReport.vue?vue&type=script&lang=js"
export * from "./DonationsReport.vue?vue&type=script&lang=js"

import "./DonationsReport.vue?vue&type=style&index=0&id=94aba2e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-94aba2e6"

export default script